import { noticeError } from '@ratehub/base-ui';

import GIC_TYPES_OPTIONS from '../definitions/GICTypesOptions';


/**
 * get the full name of the given GIC account type
 *
 * @param {string} gicType
 * @param {import('react-intl').IntlShape} intl
 * @return {string} GIC type name, for example: 'Non-registered'
 */
function getGICTypeName(gicType, intl) {
    const message = GIC_TYPES_OPTIONS.find(option => option.value === gicType)?.label;

    if (!message) {
        noticeError(new RangeError(`[getGICTypeName] Invalid GIC type “${gicType}”.`), {
            expectedValues: `[ '${GIC_TYPES_OPTIONS.map(option => option.value).join('\', \'')}' ]`,
        });
        return '';
    }

    return intl.formatMessage(message);
}

export default getGICTypeName;
